module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("推广方法")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.\t如何推广我的录制作品呢？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "460px",
      "height": "190px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_3.png")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "390px",
      "height": "410px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_6.png")
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "474px",
      "height": "200px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_7.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2. 如何申请Podcast服务？")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "590px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_8.png")
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "530px",
      "height": "270px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_9.png")
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "620px",
      "height": "220px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_10.png")
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "190px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_11.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3. 主播社群运营策略")]), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("首先，上传成功后立即分享节目，获取更多播放机会。")]), _vm._v(" "), _c('br'), _vm._v("当你的节目通过审核，收到提醒，此时是不是已经迫不及待地要与你的好友或者粉丝分享你的声音作品了呢？那就立刻分享到 微博、微信、QQ空间等，获取第一批高播放量。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("其次，利用微信公众号推广利器——微电台。")]), _vm._v(" "), _c('br'), _vm._v("使用微电台进行简单的设置，就可以让微信公众号粉丝和微信好友都来收听你的节目啦。同步增加播放量就是这么简单！提示：您可以在喜马拉雅FM网端“管理中心”进行个性化设置、获取微电台网址，以及了解相关教程。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("再次，引导粉丝订阅。")]), _vm._v(" "), _c('br'), _vm._v("拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享专辑给您的朋友们“求订阅”！\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("申请Podcast服务，需要满足以下几个要求：")]), _vm._v(" "), _c('br'), _vm._v("1.请确保你希望提交的专辑至少有3期节目。 2.准备好一张1400*1400像素以上的图片作为封面。3.我们鼓励原创内容，如有侵权内容可能无法通过。 4.合理的节目更新频率可以让你有效提升收听率。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("申请Podcast服务的流程如下：")]), _vm._v(" "), _c('br'), _vm._v("您需要通过喜马拉雅网站网页端进行申请流程。进入方式：个人主页—管理中心—推广中心—Podcast服务随后即可点击“新建申请”，按照流程进行下一步操作：\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("申请通过后如何发布到苹果商店？")]), _vm._v(" "), _c('br'), _vm._v("当您申请成功，喜马拉雅会协助合作伙伴用户直接提交完成，但多数情况下可能需要您自行通过苹果官方渠道提交播客，获取RSS地址后可通过下面的网址进行提交：https://podcastsconnect.apple.com/\n        "), _c('br'), _vm._v("注：RSS地址请在网页端获取！整个提交过程需要通过苹果官方网站完成，请事先拥有一个iTunes账户并登陆：\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("如何获取自己的RSS地址")]), _vm._v(" "), _c('br'), _vm._v("进入方式：个人主页—管理中心—推广中心—Podcast服务随后点击专辑名称，进入以下页面即可显示RSS地址\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("申请成功后为什么搜索不到？")]), _vm._v(" "), _c('br'), _vm._v("一：这可能取决于苹果服务器的更新情况，一般需要24小时左右。\n        "), _c('br'), _vm._v("二：你的节目可能不适宜在苹果商店展示，原因可能如下：你的节目太少，或者已经停止更新；你的封面图片不符合苹果公司的政策法规；你节目中使用的相关素材，涉及到版权风险；内容不适合发布；Podcast不接受此类型作品；您的相关作品无法判断是否获得相关文字及内容版权。\n        "), _c('br'), _vm._v("提示：您可以通过苹果官方网站重新提交申请，但如果因为下架原因，则此专辑将无法进行再次申请。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("如何删除Podcast服务？")]), _vm._v(" "), _c('br'), _vm._v("注意：删除Podcast服务将不可再恢复。如果是您自己通过iTunes账号提交的Podcast请自行"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://podcastsconnect.apple.com/"
    }
  }, [_vm._v("登录")]), _vm._v("管理页面,进行删除；如果是喜马拉雅FM协助您提交的Podcast服务请邮件联系我们进行删除。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("关于Podcast相关技术问题")]), _vm._v(" "), _c('br'), _vm._v("请"), _c('a', {
    attrs: {
      "href": "https://itunespartner.apple.com/cn/podcasts/overview",
      "target": "_blank"
    }
  }, [_vm._v("登录")]), _vm._v("苹果公司网站进行查询\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("为什么提示<description> 标签错误？")]), _vm._v(" "), _c('br'), _vm._v("请为您的专辑添加简介，或在Podcast设置里面添加自定义“播客描述”：\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("请查看：\n        "), _c('br'), _c('a', {
    attrs: {
      "href": "http://blog.ximalaya.com/%e5%96%9c%e9%a9%ac%e6%8b%89%e9%9b%85%e7%a4%be%e7%be%a4%e6%94%bb%e7%95%a51-0/",
      "target": "_blank"
    }
  }, [_vm._v("喜马拉雅社群攻略 1.0")]), _vm._v(" "), _c('br'), _c('a', {
    attrs: {
      "href": "http://blog.ximalaya.com/%e5%96%9c%e9%a9%ac%e6%8b%89%e9%9b%85%e7%a4%be%e7%be%a4%e6%94%bb%e7%95%a52-0/",
      "target": "_blank"
    }
  }, [_vm._v("喜马拉雅社群攻略  2.0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9dcfd748!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/Popularize.vue
// module id = 383
// module chunks = 0